import {
  apiGetRiskCenterOverview,
  apiGetRiskCenterScenarios,
} from '../../api/riskCenter';
import { SCENARIO_COLUMNS, STRATEGY_FUTURES } from '../../config/riskCenter';

export default {
  namespaced: true,

  state: () => ({
    overview: null,
    scenarios: null,
    selectedStrategyId: STRATEGY_FUTURES,
    assumptions: {},
    loading: false,
  }),

  getters: {
    hasSoybeans(state) {
      return Boolean(state.overview?.has_soybeans);
    },

    selectedStrategy(state) {
      const list = state.scenarios?.strategies || [];
      return list.find((s) => s.id === state.selectedStrategyId) || list[0] || null;
    },

    highlightedColumnKey(state) {
      const match = SCENARIO_COLUMNS.find((c) => c.strategyId === state.selectedStrategyId);
      return match ? match.key : null;
    },
  },

  mutations: {
    setOverview(state, payload) {
      state.overview = payload || null;
    },

    setScenarios(state, payload) {
      state.scenarios = payload || null;
    },

    setSelectedStrategy(state, strategyId) {
      state.selectedStrategyId = strategyId;
    },

    setAssumptions(state, payload) {
      state.assumptions = payload || {};
    },

    setLoading(state, value) {
      state.loading = Boolean(value);
    },
  },

  actions: {
    async loadRiskCenter({ commit }) {
      commit('setLoading', true);
      try {
        const [overview, scenarios] = await Promise.all([
          apiGetRiskCenterOverview(),
          apiGetRiskCenterScenarios(),
        ]);
        commit('setOverview', overview);
        commit('setScenarios', scenarios);
        commit('setAssumptions', scenarios?.assumptions || {});
      } finally {
        commit('setLoading', false);
      }
    },

    async applyAssumptions({ commit }, assumptions) {
      const scenarios = await apiGetRiskCenterScenarios({ assumptions });
      commit('setScenarios', scenarios);
      commit('setAssumptions', scenarios?.assumptions || {});
    },

    selectStrategy({ commit }, strategyId) {
      commit('setSelectedStrategy', strategyId);
    },
  },
};
